import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white text-ink" data-id="element-90" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-91" data-mp="9u38o47kog6z">
        <p className="text-xs font-bold uppercase tracking-widest text-forge" data-id="element-92" data-mp="etft6iaz1b6e">
          Tu inversión está protegida
        </p>

        <Reveal className="mt-2 flex items-start gap-3 rounded-xl border-2 border-gold bg-paper p-3 text-left" data-id="element-93" data-mp="jrhezazs7olk">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-ink" data-id="element-94" data-mp="nst6jm27ujwe">
            <ShieldCheckIcon size={20} className="text-gold" data-id="element-95" data-mp="sldzymh7muze" />
          </span>
          <div data-id="element-96" data-mp="xivxlgps1ns3">
            <h2 id="garantia" className="text-sm font-extrabold uppercase leading-tight sm:text-base" data-id="element-97" data-mp="xjfhh2yzmm8r">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-0.5 text-xs leading-snug text-steel sm:text-sm" data-id="element-98" data-mp="17ims3iec82s6">
              Tenés 7 días para explorar los 6 tomos y los 5 bonos. Si
              considerás que el sistema no es adecuado para vos, podés
              solicitar un reembolso dentro del período establecido según los
              términos de devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}